'use es6';

import { bufferedCloseToEdgeDistancesWithNestedRows, hoverTypes, layoutNodeTypes } from 'layout-dnd-utils/constants/dndAreaHoverPositionConstants';
import { closeToEdgeDistancePerTriangle, horizontalAndVericalCloseToEdgeDistanceForThisNode, isCloseToLeftOrRightEdge as getIsCloseToLeftOrRightEdge, isCloseToTopOrBottomEdge as getIsCloseToTopOrBottomEdge, isTrianglePositionCloseToEdgeOfBounds
// @ts-expect-error not yet migrated
} from 'layout-dnd-utils/geometry/triangle';
// @ts-expect-error not yet migrated
import { isPositionWithinBounds } from 'layout-dnd-utils/geometry/basic';
export const isSiblingNode = (nodeA, nodeB) => {
  if (nodeA.type !== layoutNodeTypes.GRID_LAYOUT_ROOT && nodeB.type !== layoutNodeTypes.GRID_LAYOUT_ROOT) {
    return nodeA.parentId === nodeB.parentId;
  } else if (nodeA.type === layoutNodeTypes.GRID_LAYOUT_ROOT && nodeB.type === layoutNodeTypes.GRID_LAYOUT_ROOT) {
    return true;
  }
  return false;
};
export const getParentNode = (node, mapOfPositionsById) => {
  if (node.type === layoutNodeTypes.GRID_LAYOUT_ROOT) {
    return null;
  }
  return mapOfPositionsById.get(node.parentId);
};
export const getPreviousDirectSiblingOfGridNode = ({
  currentNodeToCheck,
  mapOfChildIdsByParentId,
  mapOfPositionsById
}) => {
  if (currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_ROOT) {
    return null;
  }
  const childIds = mapOfChildIdsByParentId.get(currentNodeToCheck.parentId);
  const currentIndex = childIds.indexOf(currentNodeToCheck.id);
  if (currentIndex === 0) {
    return null;
  }
  return mapOfPositionsById.get(childIds[currentIndex - 1]);
};
export const getNextDirectSiblingOfGridNode = ({
  currentNodeToCheck,
  mapOfChildIdsByParentId,
  mapOfPositionsById
}) => {
  if (currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_ROOT) {
    return null;
  }
  const childIds = mapOfChildIdsByParentId.get(currentNodeToCheck.parentId);
  const currentIndex = childIds.indexOf(currentNodeToCheck.id);
  if (currentIndex === childIds.length - 1) {
    return null;
  }
  return mapOfPositionsById.get(childIds[currentIndex + 1]);
};
export const isBetweenTwoDirectSiblings = ({
  adjustedMouseCoords,
  currentNodeToCheck,
  previousSibling,
  mapOfPositionsById
}) => {
  if (currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_ROOT) {
    return false;
  }
  const parentNode = mapOfPositionsById.get(currentNodeToCheck.parentId);
  if (parentNode.type === layoutNodeTypes.GRID_LAYOUT_GRID) {
    return isPositionWithinBounds(adjustedMouseCoords, {
      top: Math.max(previousSibling.top, currentNodeToCheck.top),
      bottom: Math.min(previousSibling.bottom, currentNodeToCheck.bottom),
      left: previousSibling.right,
      right: currentNodeToCheck.left
    });
  }
  const isHorizontallyBetween = isPositionWithinBounds(adjustedMouseCoords, {
    top: parentNode.top,
    bottom: parentNode.bottom,
    left: previousSibling.right,
    right: currentNodeToCheck.left
  });
  const isVerticallyBetween = isPositionWithinBounds(adjustedMouseCoords, {
    top: previousSibling.bottom,
    bottom: currentNodeToCheck.top,
    left: parentNode.left,
    right: parentNode.right
  });
  return isHorizontallyBetween || isVerticallyBetween;
};
export const computeClosenessToAllEdges = ({
  adjustedMouseCoords,
  currentNodeToCheck,
  deepestHoveredNode,
  leftOrRightHovered,
  topOrBottomHovered,
  triangleHovered
}) => {
  // Subtract one to account for the layout section node.
  const deepestRowAndColumnIndex = Math.floor((deepestHoveredNode.depth - 1) / 2);
  // Add 1 to begin index after the layout section.
  const currentRowAndColumnIndex = Math.floor((currentNodeToCheck.depth + 1) / 2);
  const isDeepestRowAndColumnIndex = currentRowAndColumnIndex >= deepestRowAndColumnIndex;

  // TODO: Come back to this later. For now we're only playing with draggable
  // modules that don't implicitly create new containers.

  // const parentRow = 'parentId' in deepestHoveredNode ? mapOfPositionsById.get(deepestHoveredNode.parentId) : ;
  // const parentColumnOrSection =
  //   parentRow && mapOfPositionsById.get(parentRow.parentId);

  // More context on "special cases" to allow nested rows here: https://git.hubteam.com/HubSpot/ContentEditorUI/issues/8596
  // allowNestedRows =
  //   allowNestedRows &&
  //   parentColumnOrSection &&
  //   parentColumnOrSection.depth >= 0 &&
  //   parentColumnOrSection.numChildRows >= 2;
  // let closeToEdgeDistances;
  // if (allowNestedRows) {
  const closeToEdgeDistances = bufferedCloseToEdgeDistancesWithNestedRows;
  // } else {
  // const closeToEdgeDistances = bufferedCloseToEdgeDistancesWithoutNestedRows;
  // }

  const {
    horizontalCloseToEdge,
    verticalCloseToEdge
  } = horizontalAndVericalCloseToEdgeDistanceForThisNode({
    // Since each buffer represents a certain percentage of width/height, we use the top-most (deepest) hovered
    // module as a reference for buffer sizes. See diagram in: https://git.hubteam.com/HubSpot/ContentEditorUI/pull/6988
    // for more context.
    width: deepestHoveredNode.width,
    height: deepestHoveredNode.height,
    isLeaf: currentNodeToCheck.type === layoutNodeTypes.GRID_LAYOUT_MODULE,
    closeToEdgeDistances,
    indexValues: {
      currentRowAndColumnIndex,
      isDeepestRowAndColumnIndex
    }
  });
  const customCloseToEdgeDistance = closeToEdgeDistancePerTriangle({
    triangleHovered,
    horizontalCloseToEdge,
    verticalCloseToEdge
  });
  const isCloseToTriangleEdge = isTrianglePositionCloseToEdgeOfBounds(customCloseToEdgeDistance, triangleHovered, adjustedMouseCoords, currentNodeToCheck);
  const isCloseToTopOrBottomEdge = getIsCloseToTopOrBottomEdge(verticalCloseToEdge, topOrBottomHovered, adjustedMouseCoords, currentNodeToCheck);
  const isCloseToLeftOrRightEdge = getIsCloseToLeftOrRightEdge(horizontalCloseToEdge, leftOrRightHovered, adjustedMouseCoords, currentNodeToCheck);
  return {
    isCloseToTriangleEdge,
    isCloseToTopOrBottomEdge,
    isCloseToLeftOrRightEdge
  };
};
export const buildHoverPositionForWithinBoundsOfNode = (node, otherHoverPositionProps) => {
  switch (node.type) {
    case layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK:
      return Object.assign({
        depth: node.depth,
        gridLayoutId: node.gridLayoutId,
        hasDelegatedBounds: false,
        hasLayoutStyles: node.hasLayoutStyles,
        id: node.id,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK,
        isEmptyGridLayout: false,
        measuredHeight: node.height,
        measuredLeft: node.left,
        measuredTop: node.top,
        measuredWidth: node.width,
        numChildren: node.numChildren,
        parentId: node.parentId,
        isGridCell: node.isGridCell,
        type: hoverTypes.INNER_TRIANGLE
      }, otherHoverPositionProps);
    case layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK:
      return Object.assign({
        depth: node.depth,
        gridLayoutId: node.gridLayoutId,
        hasDelegatedBounds: false,
        hasLayoutStyles: node.hasLayoutStyles,
        id: node.id,
        isEmptyGridLayout: false,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK,
        measuredHeight: node.height,
        measuredLeft: node.left,
        measuredTop: node.top,
        measuredWidth: node.width,
        numChildren: node.numChildren,
        parentId: node.parentId,
        isGridCell: node.isGridCell,
        type: hoverTypes.INNER_TRIANGLE
      }, otherHoverPositionProps);
    case layoutNodeTypes.GRID_LAYOUT_GRID:
      return Object.assign({
        depth: node.depth,
        gridLayoutId: node.gridLayoutId,
        hasDelegatedBounds: false,
        hasLayoutStyles: node.hasLayoutStyles,
        id: node.id,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_GRID,
        isEmptyGridLayout: false,
        measuredHeight: node.height,
        measuredLeft: node.left,
        measuredTop: node.top,
        measuredWidth: node.width,
        numChildren: node.numChildren,
        parentId: node.parentId,
        isGridCell: node.isGridCell,
        type: hoverTypes.INNER_TRIANGLE
      }, otherHoverPositionProps);
    case layoutNodeTypes.GRID_LAYOUT_MODULE:
      return Object.assign({
        depth: node.depth,
        gridLayoutId: node.gridLayoutId,
        hasDelegatedBounds: false,
        hasLayoutStyles: node.hasLayoutStyles,
        id: node.id,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_MODULE,
        measuredHeight: node.height,
        measuredLeft: node.left,
        measuredTop: node.top,
        measuredWidth: node.width,
        parentId: node.parentId,
        isGridCell: node.isGridCell,
        type: hoverTypes.INNER_TRIANGLE
      }, otherHoverPositionProps);
    case layoutNodeTypes.GRID_LAYOUT_SECTION:
      return Object.assign({
        depth: node.depth,
        gridLayoutId: node.gridLayoutId,
        hasDelegatedBounds: false,
        hasLayoutStyles: node.hasLayoutStyles,
        id: node.id,
        isEmptyGridLayout: false,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_SECTION,
        measuredHeight: node.height,
        measuredLeft: node.left,
        measuredTop: node.top,
        measuredWidth: node.width,
        numChildren: node.numChildren,
        parentId: node.parentId,
        isGridCell: node.isGridCell,
        type: hoverTypes.INNER_TRIANGLE
      }, otherHoverPositionProps);
    case layoutNodeTypes.GRID_LAYOUT_ROOT:
      {
        const isEmptyGridLayout = node.numChildren === 0 || !node.numChildren && !otherHoverPositionProps.firstChildId;
        return Object.assign({
          depth: node.depth,
          gridLayoutId: node.id,
          hasDelegatedBounds: false,
          id: node.id,
          isEmptyGridLayout,
          layoutNodeType: layoutNodeTypes.GRID_LAYOUT_ROOT,
          measuredHeight: node.height,
          measuredLeft: node.left,
          measuredTop: node.top,
          measuredWidth: node.width,
          isGridCell: node.isGridCell,
          type: hoverTypes.INNER_TRIANGLE
        }, otherHoverPositionProps);
      }
    default:
      throw new Error(`Attempting to get hover position for unimplemented node position: ${node}`);
  }
};
export const buildHoverPositionForBetweenSiblings = ({
  node,
  parentNode,
  previousSibling,
  otherHoverPositionProps
}) => {
  switch (parentNode.type) {
    case layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK:
      return Object.assign({
        depth: node.depth,
        hasDelegatedBounds: false,
        gridLayoutId: node.gridLayoutId,
        id: parentNode.id,
        leftId: previousSibling.id,
        measuredTop: previousSibling.top,
        measuredHeight: previousSibling.height,
        measuredLeftMidpoint: (previousSibling.right + node.left) / 2,
        parentId: previousSibling.parentId,
        rightId: node.id,
        isGridCell: false,
        type: hoverTypes.BETWEEN_HORIZONTAL_STACK_CHILDREN,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK
      }, otherHoverPositionProps);
    case layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK:
      return Object.assign({
        bottomId: node.id,
        depth: node.depth,
        hasDelegatedBounds: false,
        gridLayoutId: node.gridLayoutId,
        id: parentNode.id,
        measuredLeft: previousSibling.left,
        measuredWidth: previousSibling.width,
        measuredTopMidpoint: (previousSibling.bottom + node.top) / 2,
        parentId: previousSibling.parentId,
        topId: previousSibling.id,
        isGridCell: false,
        type: hoverTypes.BETWEEN_VERTICAL_STACK_CHILDREN,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK
      }, otherHoverPositionProps);
    case layoutNodeTypes.GRID_LAYOUT_GRID:
      return Object.assign({
        depth: node.depth,
        gridLayoutId: node.gridLayoutId,
        hasDelegatedBounds: false,
        id: parentNode.id,
        leftId: previousSibling.id,
        measuredTop: previousSibling.top,
        measuredHeight: previousSibling.height,
        measuredLeftMidpoint: (previousSibling.right + node.left) / 2,
        parentId: previousSibling.parentId,
        rightId: node.id,
        isGridCell: false,
        type: hoverTypes.BETWEEN_GRID_TABLE_CHILDREN,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_GRID
      }, otherHoverPositionProps);
    default:
      return false;
  }
};
export const buildHoverPositionForBeforeChildren = ({
  node,
  childrenIds,
  otherHoverPositionProps
}) => {
  switch (node.type) {
    case layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK:
      return Object.assign({
        depth: node.depth,
        gridLayoutId: node.gridLayoutId,
        hasDelegatedBounds: false,
        hasLayoutStyles: node.hasLayoutStyles,
        id: node.id,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK,
        isEmptyGridLayout: false,
        measuredHeight: node.height,
        measuredLeft: node.left,
        measuredTop: node.top,
        measuredWidth: node.width,
        numChildren: node.numChildren,
        parentId: node.parentId,
        type: hoverTypes.BEFORE_CHILDREN
      }, childrenIds, otherHoverPositionProps);
    case layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK:
      return Object.assign({
        depth: node.depth,
        gridLayoutId: node.gridLayoutId,
        hasDelegatedBounds: false,
        hasLayoutStyles: node.hasLayoutStyles,
        id: node.id,
        isEmptyGridLayout: false,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK,
        measuredHeight: node.height,
        measuredLeft: node.left,
        measuredTop: node.top,
        measuredWidth: node.width,
        numChildren: node.numChildren,
        parentId: node.parentId,
        type: hoverTypes.BEFORE_CHILDREN
      }, childrenIds, otherHoverPositionProps);
    default:
      return false;
  }
};
export const buildHoverPositionForSectionContainerBuffer = ({
  node,
  bufferBounds
}) => {
  const baseNodeProps = {
    id: node.id,
    depth: node.depth,
    gridLayoutId: node.gridLayoutId,
    measuredHeight: node.height,
    measuredTop: node.top,
    measuredWidth: node.width,
    numChildren: node.numChildren,
    parentId: node.parentId,
    isGridCell: node.isGridCell,
    isEmptyGridLayout: false,
    hasDelegatedBounds: false,
    hasLayoutStyles: node.hasLayoutStyles
  };
  if (node.type === layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK) {
    if (bufferBounds.isLeftBuffer) {
      return Object.assign({
        type: hoverTypes.SECTION_CONTAINER_LEFT_WHITESPACE,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK
      }, baseNodeProps);
    }
    if (bufferBounds.isRightBuffer) {
      return Object.assign({
        type: hoverTypes.SECTION_CONTAINER_RIGHT_WHITESPACE,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK
      }, baseNodeProps);
    }
  }
  if (node.type === layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK) {
    if (bufferBounds.isTopBuffer) {
      return Object.assign({
        type: hoverTypes.SECTION_CONTAINER_TOP_WHITESPACE,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK
      }, baseNodeProps);
    }
    if (bufferBounds.isBottomBuffer) {
      return Object.assign({
        type: hoverTypes.SECTION_CONTAINER_BOTTOM_WHITESPACE,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK
      }, baseNodeProps);
    }
  }
  return null;
};
export const buildHoverPositionForAfterChildren = ({
  node,
  childrenIds,
  otherHoverPositionProps
}) => {
  switch (node.type) {
    case layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK:
      return Object.assign({
        depth: node.depth,
        gridLayoutId: node.gridLayoutId,
        hasDelegatedBounds: false,
        hasLayoutStyles: node.hasLayoutStyles,
        id: node.id,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_VERTICAL_STACK,
        isEmptyGridLayout: false,
        measuredHeight: node.height,
        measuredLeft: node.left,
        measuredTop: node.top,
        measuredWidth: node.width,
        numChildren: node.numChildren,
        parentId: node.parentId,
        isGridCell: node.isGridCell,
        type: hoverTypes.AFTER_CHILDREN
      }, childrenIds, otherHoverPositionProps);
    case layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK:
      return Object.assign({
        depth: node.depth,
        gridLayoutId: node.gridLayoutId,
        hasDelegatedBounds: false,
        hasLayoutStyles: node.hasLayoutStyles,
        id: node.id,
        isEmptyGridLayout: false,
        layoutNodeType: layoutNodeTypes.GRID_LAYOUT_HORIZONTAL_STACK,
        measuredHeight: node.height,
        measuredLeft: node.left,
        measuredTop: node.top,
        measuredWidth: node.width,
        numChildren: node.numChildren,
        parentId: node.parentId,
        isGridCell: node.isGridCell,
        type: hoverTypes.AFTER_CHILDREN
      }, childrenIds, otherHoverPositionProps);
    default:
      return false;
  }
};
export function isFirstChildOfContainer(parentNode, mapOfChildIdsByParentId, currentNodeId) {
  const childrenIdsForCurrentNode = mapOfChildIdsByParentId.get(parentNode.id);
  return !!childrenIdsForCurrentNode && childrenIdsForCurrentNode.length > 0 && childrenIdsForCurrentNode[0] === currentNodeId;
}
export function isLastChildOfContainer(parentNode, mapOfChildIdsByParentId, currentNodeId) {
  const childrenIdsForCurrentNode = mapOfChildIdsByParentId.get(parentNode.id);
  return !!childrenIdsForCurrentNode && childrenIdsForCurrentNode.length > 0 && childrenIdsForCurrentNode[childrenIdsForCurrentNode.length - 1] === currentNodeId;
}